import { render, staticRenderFns } from "./PAlert.vue?vue&type=template&id=d5e695c4&scoped=true"
import script from "./PAlert.vue?vue&type=script&lang=js"
export * from "./PAlert.vue?vue&type=script&lang=js"
import style0 from "./PAlert.vue?vue&type=style&index=0&id=d5e695c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e695c4",
  null
  
)

export default component.exports